<div class="flex justify-center items-center mt-30">
  <div class="block max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-100">
    <h5 class="mb-2 text-2xl font-bold tracking-tight text-amazone-orange">Signed out</h5>
    <p class="font-normal text-gray-700">You have been successfully signed out.</p>
    <p class="font-normal text-red-800">It is recommended to close this browser window now.</p>
  </div>
</div>
